import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25fbefe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = {
  key: 0,
  class: "swipe-box"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "after-goods-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "shop-bar" }
const _hoisted_8 = {
  key: 0,
  class: "shop-title"
}
const _hoisted_9 = { class: "store_name" }
const _hoisted_10 = {
  key: 1,
  class: "order-id"
}
const _hoisted_11 = {
  key: 2,
  class: "shop-title"
}
const _hoisted_12 = { class: "fn-button" }
const _hoisted_13 = {
  key: 0,
  class: "after-state"
}
const _hoisted_14 = { class: "after-state-l" }
const _hoisted_15 = { class: "after-time" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ends in", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_18 = { class: "after-state-r" }
const _hoisted_19 = {
  key: 0,
  class: "after-goods-b-btn"
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "btn" }

import { ref, inject, shallowRef, reactive, watch } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { Toast } from 'vant'
import Header from "@/components/header/header.vue";
import KiliButton from "@/components/KiliButton.vue";
import AfterGoodsCard from "./component/afterGoodsCard.vue";
import {linkChat,getRuleUrl} from '@/hooks/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const $http: any = inject("$http");
const $store: any = inject("$store");
const loading = ref(false)
const finished = ref(false)
const product = reactive({
    size: 5,
    page: 1,
});
const tabName = ref(route.query.name ? route.query.name : "state_apply")
const isFlog = ref(false)
const orderSn = ref(route.query.order_sn != '' ? route.query.order_sn: "")
const skipPath:any = ref(route.query.kong_token ? '/':'/usercenter')
const tabList = shallowRef([
    { name: "Apply", value: "state_apply" },
    { name: "Processing", value: "state_proces" },
    { name: "Review", value: "state_review" },
    { name: "All", value: "state_all" },
]);
let afterDataList = ref([]) as any
let btnData = ref([
    {
        plain: true,
        textColor: '#666666',
        bordersColor: '#99999',
        title: 'Contact Seller',
    },
    {
        plain: false,
        textColor: '#E04545',
        bordersColor: '#E04545',
        title: 'Continue',
    }
])
let showDialog = ref(false)
let popupValue = ref('')
let ruleUrl = ref('')
let cancelParam = reactive({})
let currentItem:any = reactive({})
let btnLoading=ref(false) // 弹窗的 继续按钮 loading
let advertisingSwiper:any = ref([]) // 广告位数据
const goToRule = async() => {
    if(ruleUrl.value){
        window.open(ruleUrl.value)
    }
}
// 从app进入当前页面,设置header组件返回按钮为一个函数,关闭当前页面
if(navigator.userAgent.indexOf("kilimall,android") > -1){
       skipPath.value = () => {
           try{
            window.appBean.finish()
          } catch(error:any){}
       } 
}
const handleBtn = async (row: any, type: number, status?: any) => {
    currentItem = row
    // type 表示当前点击按钮类型 1:同意 2:寄货 3:取消 4:修改 5:详情 6:评论
    if (type === 1 || type === 5) {
        // 同意/详情 进入到详情页
        router.push({
            path: '/afterSaleDetails/' + row.id,
            query: {
                name: tabName.value
            }
        })

    } else if (type === 2) {
        // 寄货
        router.push({
            path: '/afterSaleExpress',
        })
        $store.setAfterId({
            afterId: row.id,
            checkId: row.available_check_id
        })
    } else if (type === 3) {
        popupValue.value = 'Please confirm whether to cancel the after-sales service order.'
        // 取消
        showDialog.value = true
        cancelParam = {
            check_id: row.available_check_id,
            check_status: status
        }
        btnData.value = [{
            plain: true,
            textColor: '#666666',
            bordersColor: '#99999',
            title: 'Contact Seller',
            },
            {
                plain: false,
                textColor: '#E04545',
                bordersColor: '#E04545',
                title: 'Continue',
            }]


    } else if (type === 4) {
        // 修改
        router.push({
            name: 'afterSaleInfo',
            params: {
                id: row.id,
            }
        })
    } else if (type === 6) {
        // 评价
        router.push({
            path: `/afterSaleEvaluation/${row.id}?store_id=${row.store_id}`,
        })
    }
}
const handleApply = (row: any, listItem: any) => {
    currentItem = listItem
    let isArray = Array.isArray(row)
    let id = isArray ? row[0].id : row.id
    if (row.apply_switch) {
        router.push({
            path: '/afterSaleType/' + id,

        })
    } else {
        showDialog.value = true
        popupValue.value = row.apply_switch_reason
        btnData.value = [{
            plain: true,
            textColor: '#666666',
            bordersColor: '#99999',
            title: 'Cancel',
        },
        {
            plain: false,
            textColor: '#E04545',
            bordersColor: '#E04545',
            title: 'Contact Seller',
        },]
    }


}
const beforeChange = () => {
    if(isFlog.value) {
        Toast.fail({
            message: 'you are trying too often,please try again later',
            duration: 3000,
        })
        return false
    }
    return  true
}
const onClick = (name: any) => {
    if(isFlog.value) {
        return false
    }
    tabName.value = name
    isFlog.value = true
    afterDataList.value = []
    router.push({
        path: "/afterSale",
        query: {
            name: name
        }
    }
    )
    product.page = 1
    finished.value = false
    if (tabName.value == 'state_apply') {
        getCanList()
    } else {
        getProcessingList(tabName.value)
    }
}
const handleContinue = async () => {
    // showDialog.value = false
    if(tabName.value != 'state_apply'){
        btnLoading.value = true
        const res1: any = await $http.setAfterSaleExpressWay(cancelParam)
        if (res1.code === 200) {
            //   取消或确认后，返回列表页
            onClick(tabName.value)
        }
        btnLoading.value = false
    }
    
}
const handlePopupBtn = async (btn:any) => {
    if(btn.title == 'Contact Seller'){
       linkChat($http,$store,currentItem.store_id)
    }else if(btn.title == 'Continue'){
        handleContinue()
    }
    showDialog.value = false
    
};
// 点击商品卡片
const handleGoodsCard = (row: any) => {
    if (tabName.value != 'state_apply') {
        router.push({
            path: '/afterSaleDetails/' + row.id,
            query: {
                name: tabName.value
            }

        })
    }
}
/** 获取tab列表数据 */
const getCanList = async () => {
    loading.value = true
    let params: any = {
        page_size: product.size,
        page: product.page,
    }
    if(orderSn.value){
        params.order_sn = orderSn.value
    }
    // 外部链接进入,重新请求站点信息
    if( $store.getSite() === null&&common.getStorage('isExLink')) {  
        let ret = await $http.site({code: 'ke'})
        if(ret.code === 200 && ret.data) {
            $store.setSite(ret.data)
        }
    }
    // loading.value = true
    const res: any = await $http.getAfterSalePreorderList(params, $store.getSite().code)
    if (res.code === 200) {
        let data = JSON.parse(JSON.stringify(res.data))
        afterDataList.value = afterDataList.value.concat(data)
        product.page += 1
        if (product.page > res.meta.last_page) {
            finished.value = true
        }
        loading.value = false
        isFlog.value = false

    } else {
        Toast.fail({
            message: res.message,
            duration: 5000,
        })
        finished.value = true
    }
    // loading.value = false
}
// 获取正在/售后列表
const getProcessingList = async (name: any) => {
    // afterDataList.value = []
    loading.value = true
    let type = ''
    if (name == 'state_proces') {
        type = "processing"
    } else if (name == 'state_review') {
        type = "comment"
    } else if (name == 'state_all') {
        type = "all"
    }
    let params: any = {
        page_size: product.size,
        page: product.page,
        query_status: type,// 售后状态 processing-售后中 done-售后完成，comment-待评论 all-全部售后列表
        // order_sn:'1',
    }
    const res: any = await $http.getAfterSaleList(params)
    if (res.code === 200) {
        let data = JSON.parse(JSON.stringify(res.data))
        data.forEach((item: any) => {
            // type  售后类型1 退款退货 2 退款 3 维修 4 换货
            switch (item.type) {
                case 1:
                    item.typeIcon = 'ic_return'
                    item.typeText = 'Return & Refund'
                    break;
                case 2:
                    item.typeIcon = 'ic_refund'
                    item.typeText = 'Refund'
                    break;
                case 3:
                    // item.typeIcon = 'ic_exchange'
                    // item.typeText = 'Exchange'
                    break;
                case 4:
                    item.typeIcon = 'ic_exchange'
                    item.typeText = 'Exchange'
                    break;
            }
            // 按钮出现顺序进行排序
            let btnArr: any = []
            if (item.available_action.some((item: any) => item == 4)) {
                btnArr = [4, 'details'].concat(item.available_action.filter((items: any) => items != 4))
            } else {
                btnArr = ['details'].concat(item.available_action)
            }
            item.available_action = btnArr
        })
        product.page += 1
        afterDataList.value = afterDataList.value.concat(data)

        if (product.page > res.meta.last_page) {
            finished.value = true
        }
        loading.value = false
        isFlog.value = false
    } else {
        Toast.fail({
            message: res.message,
            duration: 5000,
        })
        finished.value = true
    }

}
const handleSwipe = (row:any) => {
    if(row.type_value.length){
        window.location.href = row.type_value
    }
}
const onLoad = () => {
    getRuleUrl().then((res: any) => {
        const { aftersale_rules }  = res.agreements
        ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
    })
    if (tabName.value == 'state_apply') {
        getCanList()
    } else {
        getProcessingList(tabName.value)
    }
}
watch(()=>tabName.value,(newVal:any)=>{
    if(newVal){
        advertisingSwiper.value = []
        let ImgCode = ''
        // 获取广告位广告 
        switch (newVal){
            case "state_apply":
                ImgCode = 'aftersale_canapply_ads'
                break;
            case "state_proces":
                ImgCode = 'aftersale_processing_ads'
                break;
            case "state_review":
                ImgCode = 'aftersale_review_ads'
                break;
            case "state_all":
                ImgCode = 'aftersale_allrecord_ads'
                break;
        }
        $http.get_advertisement({ code: ImgCode }).then((res: any) => {
        if (res.code === 200 && res != null) {
            advertisingSwiper.value = res.data;
        }
        });
    }
   
},{immediate:true})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Return/Refund",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: skipPath.value,
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["skipPath"]),
    (_unref(advertisingSwiper).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_van_swipe, {
            class: "my-swipe",
            autoplay: 3000,
            "indicator-color": "white",
            "lazy-render": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advertisingSwiper), (itemImg) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, {
                  key: itemImg.image,
                  onClick: ($event: any) => (handleSwipe(itemImg))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.webpFilters(itemImg.image)
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_tabs, {
      active: tabName.value,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((tabName).value = $event)),
      sticky: "",
      "offset-top": "50px",
      "swipe-threshold": "4",
      onClick: onClick,
      "before-change": beforeChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (item) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: item.name,
            name: item.value,
            key: item.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: loading.value,
                "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
                finished: finished.value,
                "loading-text": "loading",
                "finished-text": "No more",
                onLoad: onLoad,
                class: _normalizeClass(_unref(advertisingSwiper).length ? '':'list-box')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(afterDataList), (listItem, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (handleGoodsCard(listItem))
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          (tabName.value == 'state_apply')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_van_icon, {
                                  name: "shop-o",
                                  class: "shopIcon",
                                  size: "0.5rem"
                                }),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(listItem.store_name), 1),
                                _createVNode(_component_van_icon, {
                                  name: "arrow",
                                  color: "#999",
                                  class: "shopIcon"
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (tabName.value != 'state_apply')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(listItem.sn), 1))
                            : _createCommentVNode("", true),
                          (listItem.type)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_van_icon, {
                                  name: `https://image.kilimall.com/kenya/wap/afterSales/${listItem.typeIcon}_2x.png`.webpFilters(),
                                  color: "#999",
                                  class: "shopIcon",
                                  size: "0.5rem"
                                }, null, 8, ["name"]),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(listItem.typeText), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(AfterGoodsCard, {
                          goodsData: listItem.order_goods,
                          orderId: listItem.order_sn,
                          onApply: ($event: any) => (handleApply($event, listItem))
                        }, null, 8, ["goodsData", "orderId", "onApply"]),
                        (tabName.value != 'state_apply' && listItem.countdown != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("p", null, _toDisplayString(listItem.service_status_text), 1),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _hoisted_17,
                                  _createVNode(_component_van_count_down, {
                                    time: (listItem.countdown * 1000),
                                    format: "DDd HH:mm:ss"
                                  }, null, 8, ["time"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_van_icon, {
                                  name: "arrow",
                                  color: "#999",
                                  class: "shopIcon"
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_6),
                      (tabName.value != 'state_apply')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem.available_action, (item) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (item === 4)
                                  ? (_openBlock(), _createBlock(KiliButton, {
                                      key: 0,
                                      plain: "",
                                      textColor: "#666666",
                                      bordersColor: "#999999",
                                      title: "Cancel",
                                      radiusSize: "6px",
                                      onClick: ($event: any) => (handleBtn(listItem, 3, item))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (item === 'details')
                                  ? (_openBlock(), _createBlock(KiliButton, {
                                      key: 1,
                                      plain: "",
                                      textColor: "#666666",
                                      bordersColor: "#999999",
                                      radiusSize: "6px",
                                      title: "Details",
                                      onClick: ($event: any) => (handleBtn(listItem, 5))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                ((listItem.available_type === 1 && item === 1) || (listItem.available_type === 4 && item === 1))
                                  ? (_openBlock(), _createBlock(KiliButton, {
                                      key: 2,
                                      plain: "",
                                      textColor: "#E04545",
                                      bordersColor: "#E04545",
                                      title: "Confirm",
                                      radiusSize: "6px",
                                      onClick: ($event: any) => (handleBtn(listItem, 1))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (listItem.available_type === 5 && item === 1)
                                  ? (_openBlock(), _createBlock(KiliButton, {
                                      key: 3,
                                      class: "products-btn",
                                      plain: "",
                                      textColor: "#E04545",
                                      bordersColor: "#E04545",
                                      title: "Return the Products",
                                      radiusSize: "6px",
                                      onClick: ($event: any) => (handleBtn(listItem, 2, item))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (listItem.available_type === 1 && item === 7)
                                  ? (_openBlock(), _createBlock(KiliButton, {
                                      key: 4,
                                      plain: "",
                                      textColor: "#E04545",
                                      bordersColor: "#E04545",
                                      title: "Edit",
                                      radiusSize: "6px",
                                      onClick: ($event: any) => (handleBtn(listItem, 4))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256)),
                            (listItem.comment_status == 0 && listItem.status == 3)
                              ? (_openBlock(), _createBlock(KiliButton, {
                                  key: 0,
                                  plain: "",
                                  textColor: "#E04545",
                                  bordersColor: "#E04545",
                                  radiusSize: "6px",
                                  title: "Review",
                                  onClick: ($event: any) => (handleBtn(listItem, 6))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ]),
                _: 2
              }, 1032, ["loading", "finished", "class"])
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_van_popup, {
      show: _unref(showDialog),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : showDialog = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(popupValue)), 1),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(btnData), (btnItem) => {
            return (_openBlock(), _createBlock(KiliButton, {
              plain: btnItem.plain,
              textColor: btnItem.textColor,
              bordersColor: btnItem.bordersColor,
              title: btnItem.title,
              onClick: ($event: any) => (handlePopupBtn(btnItem))
            }, null, 8, ["plain", "textColor", "bordersColor", "title", "onClick"]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})